import client from './main-client';

export const updateUserSettingsApi = (params) => client().patch(`/user-settings/${params.id}`, params.values);

export const getUserSettingsApi = (params) => client().get(`user-settings?userId=${params.id}`, params.values);
